import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {getTimezonesList} from 'sources/timezone/timeHelper';
import {FormDropDownList} from 'components/controls'

const TIMEZONES = getTimezonesList();


export default class TimezoneDropdownList extends Component {
    static propTypes = {
        value: PropTypes.any,
        onChange: PropTypes.func.isRequired,
        fieldKey: PropTypes.string.isRequired,
        error: PropTypes.any
    };

    render() {
        const {value, onChange, fieldKey, error} = this.props;
        return (
            <FormDropDownList fieldKey={fieldKey}
                              label={loc('timezone-label')}
                              placeholder={loc('timezone-placeholder')}
                              items={TIMEZONES}
                              canBeNotSelected
                              searchable
                              error={error}
                              formatter={::this.formatTimezone}
                              value={value}
                              onChange={onChange}/>
        );
    }

    formatTimezone = value => {
        if (!value)
            return loc('choose');
        return value.displayName;
    };
}


// WEBPACK FOOTER //
// ./src/components/controls/TimezoneDropdownList.js